import { createContext, useContext, useState, lazy, Suspense, ReactNode } from "react";

const ContactFormDialog = lazy(() => import("@/components/ContactFormDialog"));

export type ContactIntent = "demo" | "contact";

interface ContactFormContextType {
  openContactForm: (intent?: ContactIntent | unknown) => void;
}

const ContactFormContext = createContext<ContactFormContextType>({
  openContactForm: () => {},
});

export const useContactForm = () => useContext(ContactFormContext);

export const ContactFormProvider = ({ children }: { children: ReactNode }) => {
  const [open, setOpen] = useState(false);
  const [intent, setIntent] = useState<ContactIntent>("demo");

  return (
    <ContactFormContext.Provider
      value={{
        openContactForm: (next?: unknown) => {
          // Tolerate `onClick={openContactForm}` (passes a MouseEvent).
          const resolved: ContactIntent = next === "contact" ? "contact" : "demo";
          setIntent(resolved);
          setOpen(true);
        },
      }}
    >
      {children}
      {open && (
        <Suspense fallback={null}>
          <ContactFormDialog open={open} onOpenChange={setOpen} intent={intent} />
        </Suspense>
      )}
    </ContactFormContext.Provider>
  );
};
